﻿import {Core} from "../Base/Core";
import {UISprite} from "./Tools/Base/UISprite";
import {UINineSliceButton} from "./Tools/Base/UINineSliceButton";

export class RewardedAdsBtn extends UISprite {
    constructor(...args) {
        super();
        this.Update = this.Update.bind(this);
        this._rect = new PIXI.Rectangle(0, 0, 1, 1);
        this.button = this.addChild(new UINineSliceButton(...args));
        this.disabler = this.addChild(new UINineSliceButton("btn-gray", {label: "wait"}));
        this.disabler.interactive = false;
        this.disabler.cursor = "wait";
        Core.on("Updated", this.Update);
    }

    fitLayout(rect = this._rect) {
        this._rect.copyFrom(rect);
        this.position.copyFrom(this._rect);
        rect = this._rect.clone();
        rect.x = rect.y = 0;
        this.button.fitLayout(rect);
        this.disabler.fitLayout(rect);
    }

    get label() {
        return this.button.label;
    }

    set label(val) {
        this.button.label = val || "";
    }

    get icon() {
        return this.button.icon;
    }

    set icon(val) {
        this.button.icon = val;
    }

    Update() {
        let t = Math.ceil(Core.Ads.nextRewardedTimeout);
        let disabled = t > 0 || !Core.Ads.rewardedAdReady;
        let changed = disabled !== this.disabler.Active;
        this.disabler.SetActive(disabled);
        this.button.SetActive(!disabled);
        this.interactive = !disabled;
        this.cursor = disabled ? "wait" : "pointer";
        if (disabled) {
            this.disabler.label = t > 0 ? `${t} sec` : this.button.label;
        }
        if (changed) {
            this.fitLayout();
        }
    }
}
